<template>
  <!-- 远程会诊 -->
  <div class="patient-list">
    <div class="listWarpper">
      <el-card class="box-card">
        <div slot="header" class="box-card-header clearfix">
          <div class="searchBox">
            <div class="searchInput mainItem">
              <el-input
                v-model="name"
                placeholder="请输入患者姓名"
                @keyup.native="nameChange"
              ></el-input>
            </div>
            <div class="searchInput mainItem">
              <el-button type="text" @click="empty">清空条件</el-button>
              <el-button class="searchInput_btn" type="primary" @click="search"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <el-table
              :data="list_data"
              @sort-change="sortChange"
              class="content-table"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                label="会诊标题"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div slot="reference" class="name-wrapper">
                    <p>
                      {{ scope.row.title }}
                    </p>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="会诊时间"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.startTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="患者姓名"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.caseContent_dictText.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="主持医生"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.doctorName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="价格"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">{{ scope.row.money || 0 }} 元</div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="创建时间"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.createTime }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="会诊状态"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ scope.row.status_dictText }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="操作"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <!-- <el-button
                    size="mini"
                    v-show="scope.row.is_eye_department == 1"
                    @click="handleCheck(scope.$index, scope.row)"
                    >阅片</el-button
                  > -->
                  <el-button
                    class="operat-button"
                    type="success"
                    size="mini"
                    v-if="scope.row.status == 0"
                    @click="CancelDiagnose(scope.row.id)"
                    >取消会诊</el-button
                  >
                  <el-button
                    class="operat-button assess-button"
                    v-if="scope.row.status == 5"
                    size="mini"
                    type="info"
                    @click="getCommentInfo(scope.$index, scope.row)"
                    >查看评价
                  </el-button>
                  <el-button
                    class="operat-button cons"
                    v-if="scope.row.status == 2"
                    size="mini"
                    type="danger"
                    @click="goCons(scope.$index, scope.row, scope)"
                    >进入会诊
                  </el-button>
                  <el-button
                    class="operat-button"
                    size="mini"
                    type="danger"
                    @click="handleDetail(scope.$index, scope.row, scope)"
                    >查看详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageWarpper" v-show="list_data != ''">
          <el-pagination
            @current-change="currentPageChange"
            :page-size="pageList.size"
            :current-page="pageList.current"
            layout="total, prev, pager, next"
            :total="pageList.total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog
      class="assess-dialog"
      title="会诊详情"
      :visible.sync="dialogVisible1"
      :center="false"
    >
      <div class="assess-dialog-userInfo">
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >会诊编号:</span
          >
          <span class="dialog-span-main"> {{ commentInfo.consNumber }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >会诊时间:</span
          >
          <span class="dialog-span-main"> {{ commentInfo.startTime }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >创建时间:</span
          >
          <span class="dialog-span-main"> {{ commentInfo.createTime }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >主持医生:</span
          >
          <span class="dialog-span-main"> {{ commentInfo.doctorName }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >互动专家:</span
          >
          <span class="dialog-span-main">
            <template v-for="(item, index) in commentInfo.expert">
              <span :key="index" v-if="item">
                {{ item.name }}
              </span>
            </template></span
          >
        </div>

        <div class="dialog-span">
          <span class="dialog-span-header">会诊状态:</span>
          <span class="dialog-span-main">{{
            commentInfo.status_dictText
          }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header"> 会诊说明:</span>
          <span class="dialog-span-main">{{ commentInfo.intro || "无" }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >患者姓名:</span
          >
          <span class="dialog-span-main"> {{ commentUserInfo.name }}</span>
        </div>

        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two">用药史:</span>
          <span class="dialog-span-main">
            {{ commentUserInfo.drugHistory }}</span
          >
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two">手术史:</span>
          <span class="dialog-span-main">
            {{ commentUserInfo.operationHistory }}</span
          >
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two">过敏史:</span>
          <span class="dialog-span-main"> {{ commentUserInfo.allergy }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >病情自述:</span
          >
          <span class="dialog-span-main"> {{ commentUserInfo.described }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two"
            >病史小结:</span
          >
          <span class="dialog-span-main">
            {{ commentUserInfo.patientHistory }}</span
          >
        </div>

        <div class="dialog-span-two">
          <span class="dialog-span-header">附件:</span>
          <div class="dialog-span-main demo-image__preview">
            <el-image
              class="annex-img"
              v-for="(item, index) in commentImgArr"
              :src="item"
              :preview-src-list="commentImgArr"
              :key="index"
              :z-index="z_index"
            >
            </el-image>
          </div>
        </div>
        <div class="dialog-span" v-if="commentInfo.status == 3">
          <span class="dialog-span-header dialog-span-header-two"
            >会诊结果:</span
          >
          <el-input
            class="textarea"
            type="textarea"
            autosize
            placeholder="请输入会诊结果"
            v-model="textarea1"
          >
          </el-input>
          <div class="btn-list">
            <el-button
              type="primary"
              size="mini"
              @click="onSubmit(commentInfo.id)"
              >提交</el-button
            >
            <el-button type="info" size="mini" class="info">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="commentInfo"
      class="assess-dialog"
      title="评价"
      :visible.sync="dialogVisible2"
      :center="false"
    >
      <div>
        <img
          class="headImg"
          :src="
            commentInfo.memberAvatar ||
            commentInfo.dHeadImageUrl ||
            defaultHeadImage
          "
        />
      </div>
      <div class="assess-dialog-userInfo">
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two">姓名:</span>
          <span class="dialog-span-main">{{ commentInfo.memberName }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header-two">诊疗类型:</span>
          <span class="dialog-span-main">{{ commentInfo.goodsTitle }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header-three">评价时间:</span>
          <span class="dialog-span-main">{{ commentInfo.createTime }}</span>
        </div>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header">评价内容:</span>
        <span class="dialog-span-main">{{ commentInfo.content }}</span>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header">附件:</span>
        <div class="dialog-span-main demo-image__preview">
          <el-image
            class="annex-img"
            v-for="(item, index) in commentImgArr"
            :src="item"
            :preview-src-list="commentImgArr"
            :key="index"
            :z-index="z_index"
          >
          </el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils";
import {
  getConsultationList,
  setCancelCons,
  getComment,
  createdConsultation,
  judgeCons,
} from "@/api/index.js";
import axios from "axios";
import moneyBackPopup from "@/components/moneyBackPopup/index.vue";

export default {
  name: "remoteInterrogation",
  data() {
    return {
      dialogVisible1: false, //查看详情
      dialogVisible2: false, // 查看评价
      imgList: [],
      z_index: 3000,
      defaultHeadImage: require("@/assets/images/default-avatar-patient.png"),

      commentInfo: {},
      commentUserInfo: {},
      tableData: [],
      pageList: {
        pageSize: 10,
        pageNo: 1,
      },
      tabName: "",

      status: "",
      name: "",
      list_data: [],
      textarea1: "",
    };
  },
  components: { moneyBackPopup },

  methods: {
    goCons(index, row, scope) {
      judgeCons({ id: row.id }).then((res) => {
        if (!res.success) {
          return this.$message({
            type: "error",
            message: res.message,
          });
        }
        if (!row.doctorImAccId) {
          this.$message({
            type: "error",
            message: "该患者已不存在或者被删除",
          });
          return;
        }
        let query = {
          tabNum: this.$route.query.tabNum,
          fromType: "workdetail",
          sessionId: "p2p-" + row.doctorImAccId,
          treatId: row.id,
          type: "consultation",
          patientName: row.patientName
        };
        if (row.id) {
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        } else {
          this.$message({
            type: "error",
            message: "当前会话已删除",
          });
        }
      });
    },
    //取消会诊
    CancelDiagnose(id) {
      this.$confirm("是否要取消会诊?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        setCancelCons({ id }).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          }
        });
      });
    },
    //提交会诊结果
    onSubmit(orderTreatId) {
      if (!this.textarea1)
        return this.$message({
          showClose: true,
          message: "请输入会诊结果后再提交！",
          type: "error",
        });
      let discussResult = this.textarea1;
      createdConsultation({ orderTreatId, discussResult }).then((res) => {
      });
    },
    //查看评价
    getCommentInfo(index, row) {
      this.$nextTick(async () => {
        try {
          const that = this;
          let params = {
            orderTreatId: row.id,
            orderType: 2,
          };
          let res = await getComment(params);
          if (res.success) {
            this.commentInfo = res.result;
            if (this.commentInfo) {
              this.dialogVisible2 = true;
            } else {
              this.$message({
                showClose: true,
                message: "暂无评价",
                type: "warning",
              });
            }
          } else {
            that.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        } catch (error) {
        }
      });
    },
    // 查看附件的放大事件
    enlargeImg(index) {
    },
    empty() {
      this.status = "";
      this.name = "";
      this.pageList.pageNo = 1;
      this.readyPatientList();
    },
    search() {
      this.pageList.pageNo = 1;
      this.readyPatientList();
    },
    //分页
    currentPageChange(page) {
      this.pageList.pageNo = page;
      this.readyPatientList();
    },

    //查看详情
    handleDetail(index, row, scope) {
      this.commentInfo = row;
      this.commentUserInfo = row.caseContent_dictText;
      this.dialogVisible1 = true;
    },
    sortChange(column, prop, order) {
    },
    //下拉列表选项改变
    optChange(val) {
      // var tabNum = this.$route.query.tabNum;
      // console.log(tabNum);
      // if (tabNum == "2") {
      //   this.readyPatientList();
      // } else if (tabNum == "3") {
      //   this.readyApointList();
      // }
      this.readyPatientList();
    },
    //关键字输入框离开事件
    nameChange() {
      console.log("name: ", this.name);
    },
    /**
     * 初次获取我的退费列表
     */
    async readyPatientList() {
      try {
        const that = this;
        let params = {
          status: that.status,
          pageNo: that.pageList.pageNo,
          pageSize: that.pageList.pageSize,
          memberName: that.name,
        };
        let res = await getConsultationList(params);
        if (res.success) {
          this.list_data = res.result.records;
          this.pageList = res.result;
        } else {
          that.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
      }
    },
  },

  created() {
    this.readyPatientList();
  },
  mounted() {},
  computed: {
    commentImgArr() {
      //图片字符串分割数组,utils内的方法
      return utils.commentImgList(this.commentInfo.image);
    },
    // evaluateBtnShow() {  //控制是否展示查看评价按钮
    //   if (this.commentInfo) {
    //     return true
    //   }else {
    //     return false
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__empty-text {
  color: #cfcbc9 !important;
  font-weight: bold;
  font-size: 18px;
  padding-top: 200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center !important;
}

.headImg {
  width: 100px;
  height: 100px;
}

/deep/ .el-table__empty-text span {
  position: relative;
  right: 10px !important;
}

/deep/ .el-dialog--center {
  width: 60% !important;
  // box-shadow: none !important;
}

/deep/ .el-dialog__body {
  margin: 0 10% !important;
  padding-top: 0;
}

.assess-button {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
}
.assess-dialog-userInfo {
  margin-top: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.operat-button {
  margin: 5px 0 0 10px !important;
}
.cons {
  background-color: #67c23a !important;
  border-color: #67c23a !important;
}
.dialog-span-two {
  margin-top: 30px;
  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-main {
    font-size: 17px;
    line-height: 30px;
    color: #000000;
    margin: 0 5px 0 35px;
    .annex-img {
      width: 100px;
      height: 100px;
      margin-right: 5px;
      padding-top: 10px;
      cursor: pointer;
    }
  }
  .demo-image__preview {
    margin: 0 !important;
  }
}
.textarea {
  margin-top: 20px;
}
.dialog-span {
  display: inline-block;
  margin-top: 20px;

  .btn-list {
    margin-top: 20px;
    display: flex;
    justify-content: center;

    .info {
      background-color: #909399;
      border: 1px solid #909399;
    }
  }

  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-header-two {
    flex: 1;
    font-size: 17px;
    color: #000000;
  }
  .dialog-span-header-three {
    flex: 1;
    font-size: 17px;
    padding: 0 10px;
    color: #000000;
  }
  .dialog-span-main {
    font-size: 17px;
    color: #000000;
    margin-top: 25px;
    margin-right: 35px;
    margin-left: 35px;
  }
}

.el-button--info {
  background: #67c23a;
  border-color: #67c23a;
}

.el-button--danger {
  background: #fc701a;
  border-color: #fc701a;
}

.patient-list {
  display: flex;
  width: 100%;
  padding: 20px;
  // .main {
  //   display: flex;
  // }
  .listWarpper {
    width: 98%;
    .box-card {
      width: 98%;
    }
  }
  .mainItem {
    float: left;
    width: 38%;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
    width: 38%;
  }

  .mainItem:nth-child(3) {
    width: 18%;
    display: flex;
    justify-content: space-around;
  }

  .pageWarpper {
    text-align: center;
  }

  .searchInput_btn {
    margin-left: 40px;
    height: 40px;
    width: 100px;
  }
}
</style>
